var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ax-spinner",
      class: { "ax-spinner--appear": _vm.show },
      attrs: { role: "presentation" }
    },
    [
      _c(
        "svg",
        {
          staticStyle: {
            margin: "auto",
            background: "none",
            display: "block",
            "shape-rendering": "auto"
          },
          attrs: {
            width: "50",
            height: "50",
            xmlns: "http://www.w3.org/2000/svg",
            "xmlns:xlink": "http://www.w3.org/1999/xlink",
            viewBox: "0 0 100 100",
            preserveAspectRatio: "xMidYMid"
          }
        },
        [
          _c(
            "circle",
            { attrs: { cx: "84", cy: "50", r: "10", fill: "#00205a" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "r",
                  repeatCount: "indefinite",
                  dur: "0.5319148936170213s",
                  calcMode: "spline",
                  keyTimes: "0;1",
                  values: "15;0",
                  keySplines: "0 0.5 0.5 1",
                  begin: "0s"
                }
              }),
              _vm._v(" "),
              _c("animate", {
                attrs: {
                  attributeName: "fill",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "discrete",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "#00205a;#007a91;#796597;#0dae8e;#00205a",
                  begin: "0s"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "circle",
            { attrs: { cx: "16", cy: "50", r: "10", fill: "#00205a" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "r",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "0;0;15;15;15",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "0s"
                }
              }),
              _vm._v(" "),
              _c("animate", {
                attrs: {
                  attributeName: "cx",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "16;16;16;50;84",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "0s"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "circle",
            { attrs: { cx: "50", cy: "50", r: "10", fill: "#0dae8e" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "r",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "0;0;15;15;15",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-0.5319148936170213s"
                }
              }),
              _vm._v(" "),
              _c("animate", {
                attrs: {
                  attributeName: "cx",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "16;16;16;50;84",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-0.5319148936170213s"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "circle",
            { attrs: { cx: "84", cy: "50", r: "10", fill: "#796597" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "r",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "0;0;15;15;15",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-1.0638297872340425s"
                }
              }),
              _vm._v(" "),
              _c("animate", {
                attrs: {
                  attributeName: "cx",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "16;16;16;50;84",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-1.0638297872340425s"
                }
              })
            ]
          ),
          _vm._v(" "),
          _c(
            "circle",
            { attrs: { cx: "16", cy: "50", r: "10", fill: "#007a91" } },
            [
              _c("animate", {
                attrs: {
                  attributeName: "r",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "0;0;15;15;15",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-1.5957446808510638s"
                }
              }),
              _vm._v(" "),
              _c("animate", {
                attrs: {
                  attributeName: "cx",
                  repeatCount: "indefinite",
                  dur: "2.127659574468085s",
                  calcMode: "spline",
                  keyTimes: "0;0.25;0.5;0.75;1",
                  values: "16;16;16;50;84",
                  keySplines: "0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1;0 0.5 0.5 1",
                  begin: "-1.5957446808510638s"
                }
              })
            ]
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }